import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  return _openBlock(), _createBlock(_component_van_action_sheet, {
    "z-index": 20001,
    show: $data.show,
    actions: $data.actionsList,
    onSelect: $options.op,
    onClose: $options.close,
    onCancel: $options.close,
    "close-on-click-overlay": true,
    "cancel-text": "取消"
  }, null, 8, ["show", "actions", "onSelect", "onClose", "onCancel"]);
}